import { AUTH_LOCAL_STORAGE_KEY } from '../helpers/AuthHelpers';
import toast from 'react-hot-toast';
import { AxiosHttpClient } from './axios-http-client';

export const axiosInstance = AxiosHttpClient.create({
  axiosConfig: {
    headers: {
      'Content-Type': 'application/json',
      'x-client': 'web',
      'x-platform': 'tenant-portal',
    },
    withCredentials: true,
  },
});

export const LOGOUT_REASON_KEY = 'logoutReason';
export const ACCOUNT_DEACTIVATED_REASON = 'account_deactivated';

const handleLogout = () => {
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  try {
    sessionStorage.setItem(LOGOUT_REASON_KEY, ACCOUNT_DEACTIVATED_REASON);
  } catch {
    // Storage can be unavailable; the redirect still logs the user out.
  }
  window.location.href = '/login';
};

// Response interceptor to handle global errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message;
    const status = error?.response?.status;
    if (message === 'tenant_is_not_active' || message === 'user_not_active') {
      handleLogout();
    }
    if (status === 429) {
      toast.error('Too many requests. Try again later after a few seconds.', {
        duration: 4000,
        style: {
          maxWidth: '327px',
        },
      });
    }
    return Promise.reject(error);
  }
);
